import { ADMIN_SITE_STORAGE_KEY, LEGACY_ADMIN_SITE_STORAGE_KEY, SITE_HEADER } from "@/brand";

export function getActiveSite(): string {
  if (typeof window === "undefined") return "";
  const boot = (window as Window & { __SITEWRAP_ACTIVE_SITE?: string }).__SITEWRAP_ACTIVE_SITE;
  if (boot && String(boot).trim()) return String(boot).trim();
  const legacyBoot = (window as Window & { __SITEWRAP_ACTIVE_SITE?: string }).__SITEWRAP_ACTIVE_SITE;
  if (legacyBoot && String(legacyBoot).trim()) return String(legacyBoot).trim();
  try {
    let s = String(localStorage.getItem(ADMIN_SITE_STORAGE_KEY) || "").trim();
    if (!s) {
      s = String(localStorage.getItem(LEGACY_ADMIN_SITE_STORAGE_KEY) || "").trim();
      if (s) localStorage.setItem(ADMIN_SITE_STORAGE_KEY, s);
    }
    return s;
  } catch {
    return "";
  }
}

export function setActiveSite(site: string): void {
  const s = String(site || "").trim();
  try {
    if (s) localStorage.setItem(ADMIN_SITE_STORAGE_KEY, s);
  } catch {
    /* ignore */
  }
  (window as Window & { __SITEWRAP_ACTIVE_SITE?: string }).__SITEWRAP_ACTIVE_SITE = s;
}

export function withSiteQuery(path: string, site?: string): string {
  const s = site || getActiveSite();
  if (!s) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}site=${encodeURIComponent(s)}`;
}

export async function dashFetch<T = unknown>(
  path: string,
  init?: RequestInit & { site?: string }
): Promise<T> {
  const site = init?.site || getActiveSite();
  const url = withSiteQuery(path, site);
  const headers = new Headers(init?.headers);
  if (site) headers.set(SITE_HEADER, site);
  const res = await fetch(url, { ...init, headers, credentials: "same-origin" });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    if (res.status === 403 && text.includes("site_forbidden") && typeof window !== "undefined") {
      const onAccount = window.location.pathname.startsWith("/dashboard/account");
      if (!onAccount) {
        window.location.replace("/dashboard/account");
        throw new Error("site_forbidden");
      }
    }
    throw new Error(text || `HTTP ${res.status}`);
  }
  const ct = res.headers.get("content-type") || "";
  if (ct.includes("application/json")) return (await res.json()) as T;
  return (await res.text()) as T;
}
